require('./mortgageRequestConditions.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classnames = require('classnames');
const { contains, isEmpty } = require('lodash');
const { withRouter } = require('react-router-dom');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @actions
const blockedAccountsActions = require('actions/blockedAccounts');
const mortgageRequestConditionsActions = require('actions/mortgageRequest/mortgageRequestConditions');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');
const sharedAccounts = require('actions/getSharedAccounts');
const mortgateRequestMovingExpensesAction = require('actions/mortgageRequest/mortgageRequestMovingExpenses');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ helpers
const { formatAmount } = require('utilities/currencyHelper');
const { getTinText } = require('utilities/tinHelper');
const { mortgagesContionsMonthlyFeeSubtitleText } = require('utilities/mortgageHelper');

// @components
const MortgageRequestInfo = require('components/mortgageRequest/mortgageRequestInfo/mortgageRequestInfo');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

// @ constants
const {
    FIPER,
    OV,
    FEIN,
    FIAE,
    MORTGAGE_WRITING_LETTER,
    INF_CUOTAS_HIPO,
    INF_GASTOS_HIPO,
    ADVERTENCIA_HIPO,
    INSURANCE_PRE_POLICY,
    NUEVA_LEY_DOC_1,
    NUEVA_LEY_DOC_2
} = require('constants/mortgageRequestDocumentsTypes');

const mortgageRequestStates = require('constants/mortgageRequestStates');
const { ACCOUNT_INTERVENTION_OWNER } = require('constants/index');
const { BLOCKED_ACCOUNTS_MORTGAGE_ASSOCIATION } = require('constants/operationCodesAccounts');
const { ACCOUNTS_CODES } = require('constants/mortgageRequestAppraisalRequest');
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');
const options = [
    mortgageRequestStates.APROBADO_RIESGOS,
    mortgageRequestStates.GENERANDO_OV,
    mortgageRequestStates.PROV_FONDOS,
    mortgageRequestStates.ESPERA_DOC_FIRMA,
    mortgageRequestStates.ESPERA_ACTA_NOTARIO,
    mortgageRequestStates.GESTION_FECHA_FIRMA,
    mortgageRequestStates.PEND_MMPP,
    mortgageRequestStates.PEND_SALDO,
    mortgageRequestStates.PEND_FIRMA,
    mortgageRequestStates.FIRMADO
];
const { MORTGAGE_TYPE_TEXT } = require('constants/mortgageRequestMortgageDataTypes');
const { MORTGAGE_TYPE } = require('constants/mortgageRequestType')
const documentsStates = [
    mortgageRequestStates.ESPERA_DOC_FIRMA,
    mortgageRequestStates.PROV_FONDOS,
    mortgageRequestStates.GESTION_FECHA_FIRMA,
    mortgageRequestStates.PEND_MMPP,
    mortgageRequestStates.ESPERA_ACTA_NOTARIO,
    mortgageRequestStates.PEND_SALDO,
    mortgageRequestStates.PEND_FIRMA
];
const mortgageRequestType = require('constants/mortgageRequestType');

class MortgageRequestConditions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
            showBindingOffer: false
        };

        this.buildTable = this.buildTable.bind(this);
        this.buildPDFLinks = this.buildPDFLinks.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.aceptedBindingOffer = this.aceptedBindingOffer.bind(this);
        this.handleRejectMovingExpenses = this.handleRejectMovingExpenses.bind(this);
        this.handleAddMovingExpenses = this.handleAddMovingExpenses.bind(this);
    }

    componentDidMount() {
        const {
            mortgageRequestState,
            mortgageRequestIsBindingOfferReset,
            requestConditions,
            requestSharedAccounts,
            requestSummaryDocumentation
        } = this.props;

        const idExpediente = mortgageRequestState.get('idExpediente');
        const estado = mortgageRequestState.get('estado');

        if (idExpediente) {
            requestConditions();
            mortgageRequestIsBindingOfferReset();
            requestSharedAccounts();
            requestSummaryDocumentation();

            switch (estado) {
                case mortgageRequestStates.PROV_FONDOS:
                case mortgageRequestStates.ESPERA_DOC_FIRMA:
                case mortgageRequestStates.ESPERA_ACTA_NOTARIO:
                case mortgageRequestStates.GESTION_FECHA_FIRMA:
                case mortgageRequestStates.PEND_MMPP:
                case mortgageRequestStates.PEND_SALDO:
                case mortgageRequestStates.PEND_FIRMA:
                case mortgageRequestStates.FIRMADO:
                    this.updateBindingOffer(true);
                    break;
                default:
                    this.updateBindingOffer(false);
                    break;
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { getBlockedAccounts, immAccounts, sharedAccountsState } = this.props;
        const sharedAccounts = sharedAccountsState.get('sharedAccounts');
        const fetchingSharedAccounts = sharedAccountsState.get('isFetching');

        if (!sharedAccounts.equals(prevProps.sharedAccountsState.get('sharedAccounts')) &&
            !isEmpty(sharedAccounts) && !fetchingSharedAccounts && !immAccounts.get('blockedAccountsSuccess')) {
            getBlockedAccounts(sharedAccounts, BLOCKED_ACCOUNTS_MORTGAGE_ASSOCIATION, true);
        }
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;

        resetBlockedAccounts();
    }

    updateBindingOffer(showBindingOffer) {
        this.setState({
            showBindingOffer
        });
    }

    getAccountsList(accounts, accountsMap) {
        return accounts.filter(accountId => {
            const accountHolder = accountsMap.getIn([accountId, 'interventionType']);
            const accountProduct = accountsMap.getIn([accountId, 'newProduct']);
            return accountHolder === ACCOUNT_INTERVENTION_OWNER && accountProduct === ACCOUNTS_CODES.CURRENT_ACCOUNT_CODE
        });
    }

    aceptedBindingOffer() {
        this.props.requestAcceptOffer(this.props.history);
    }

    buildAccountSelect() {
        const { immAccounts,
            mortgageRequestState,
            mortgageRequestConditionsState,
            sharedAccountsState } = this.props;
        const state = mortgageRequestState.get('estado');
        const accountId = mortgageRequestConditionsState.get('accountId');
        const sharedAccounts = sharedAccountsState.get('sharedAccounts');
        const fetchingSharedAccounts = sharedAccountsState.get('isFetching');
        const accountsIndexes = Object.keys(sharedAccounts.toJS());
        const label = <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_linkUpAccount" />;
        const optionalElement = <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_linkUpAccountSecondLabel" />;
        let content = null;
        const disclaimer = {
            warning: 'mortgageRequestConditionsRequest-mortgageRequestConditionsRequest_blockedAccountsWarning',
            important: 'mortgageRequestConditionsRequest-mortgageRequestConditionsRequest_blockedAccountsImportant'
        };
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        if (fetchingSharedAccounts || immAccounts.get('blockedAccountsLoading')) {
            content = (
                <div className="row no-outside-gutter mortgage-request-conditions__link-account-section">
                    <LoadingSection />
                </div>
            );
        } else if (options.indexOf(state) > -1) {
            if (mortgageRequestStates.APROBADO_RIESGOS === state) {
                content = (
                    <div className="row no-outside-gutter mortgage-request-conditions__link-account-section">
                        <div className="mortgage-request-conditions__link-account-section__title">
                            <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_linkUpAccountTitle" />
                        </div>
                        <p className="mortgage-request-conditions__link-account-section__offer">
                            {label}
                        </p>
                        {optionalElement}
                        <div className="row mortgage-request-conditions__link-account-section__select-account">
                            <div className="col-xs-8">
                                <DropdownAccounts
                                    blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                                    disclaimer={disclaimer}
                                    immAccounts={sharedAccounts}
                                    currentAccountId={accountId}
                                    accountsIndexes={accountsIndexes}
                                    onAccountChange={this.handleAccountChange}
                                    loading={isBlockedAccountsLoading}
                                />
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return content;
    }

    buildDownloadLink(documentText, documentType) {
        return (
            <div>
                <i
                    className="ok-link__icon icon-documento mortgage-request-conditions__ok-link-document-icon"
                    onClick={evt => this.handleFileDownload(evt, documentType)}
                />
                <a
                    href="#"
                    className="ok-link ok-link--on-table mortgage-request-conditions__ok-link-document-text"
                    onClick={evt => this.handleFileDownload(evt, documentType)}
                >
                    {documentText}
                </a>
            </div>
        );
    }

    buildNotFoundText(notFoundMessage) {
        return (
            <div className="mortgage-request-conditions">
                <span>{notFoundMessage}</span>
            </div>
        );
    }

    buildPDFLinks(type, documentText, notFoundText) {
        const { summaryDocsState } = this.props;

        if (summaryDocsState.get('isFetching')) {
            return (
                <div>
                    <LoadingSection />
                    <br />
                    <br />
                </div>
            );
        }

        if (this.checkFile(type)) {
            return this.buildDownloadLink(documentText, type);
        }

        if (notFoundText) {
            return this.buildNotFoundText(notFoundText);
        }
    }

    buildMortgageAmountContent(labelKey) {
        const { mortgageRequestConditionsType } = this.props;
        const formattedMortgageAmount = MortgageRequestCurrencyHelp({
            currency: mortgageRequestConditionsType.get('mortgageAmount'),
            withDecimals: false
        });
        return (
            <li className="mortgage-request-conditions__separator row no-outside-gutter">
                <div className="mortgage-request-conditions__table-content--item col-xs-6">
                    <FormattedText value={labelKey} />
                </div>
                <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                    <span>
                        {formattedMortgageAmount}
                    </span>
                </div>
            </li>
        );
    }

    buildTermContent() {
        const { mortgageRequestConditionsState } = this.props;
        const plazo = mortgageRequestConditionsState.getIn(['conditions', 'plazo']);
        return (
            <li className="mortgage-request-conditions__separator row no-outside-gutter">
                <div className="mortgage-request-conditions__table-content--item col-xs-6">
                    <FormattedText value="mortgageRequestConditions-plazo" />
                </div>
                <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                    <span>{`${plazo} ${formatText(
                        'mortgageRequestConditions-years'
                    )}`}</span>
                </div>
            </li>
        );
    }

    buildAmountWithMovingExpenses() {
        const { mortgageRequestConditionsState } = this.props;
        const hasMovingFees = this.hasMovingCost();
        const movingCost = mortgageRequestConditionsState.getIn(['conditions', 'importeFinanciarGastos']);
        const formattedMovingCost = MortgageRequestCurrencyHelp({ currency: movingCost });
        const importe = mortgageRequestConditionsState.getIn(['conditions', 'importeHipoteca']);
        const currencyHelpParams = {
            currency: importe,
            withDecimals: false
        }
        const amount = MortgageRequestCurrencyHelp(currencyHelpParams);
        const mortgageAmountContent = this.buildMortgageAmountContent('mortgageRequestConditions-mortgageRequestConditions_mortgageAmount');
        const termContent = this.buildTermContent();

        let content;

        if (hasMovingFees) {
            const icon = (
                <i className="icon icon-informacion mortgage-request-conditions__table-content--tooltip" />
            );
            const iconTooltip = (
                <OKTooltip
                    content="mortgageRequestConditions-mortgageRequestConditions_movingFeeTooltip"
                    offset={[0, -10]}
                    target={icon}
                />
            );

            content = (
                <React.Fragment>
                    {mortgageAmountContent}
                    <li className="mortgage-request-conditions__separator row no-outside-gutter">
                        <div className="mortgage-request-conditions__table-content--item col-xs-6">
                            <FormattedText value="mortgageRequestConditions-movingCostLabel" />
                            {iconTooltip}
                        </div>
                        <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                            <span>
                                {formattedMovingCost}
                            </span>
                        </div>
                    </li>
                    <li className="mortgage-request-conditions__separator row no-outside-gutter">
                        <div className="mortgage-request-conditions__table-content--item col-xs-6">
                            <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_mortgageMovingAmount" />
                        </div>
                        <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                            <span>
                                {amount}
                            </span>
                        </div>
                    </li>
                    {termContent}
                </React.Fragment>
            )
        }

        return content
    }

    buildAmountWithoutMovingExpenses() {
        const mortgageAmountContent = this.buildMortgageAmountContent('mortgageRequestConditions-mortgageRequestConditions_totalMortgageAmount');
        const termContent = this.buildTermContent();

        return (
            <React.Fragment>
                {termContent}
                {mortgageAmountContent}
            </React.Fragment>
        )
    }

    buildTable() {
        const { mortgageRequestConditionsState, mortgageRequestConditionsType } = this.props;
        const conditions = mortgageRequestConditionsState.get('conditions');
        const titular = conditions.get('titular');
        const noSolicitud = conditions.get('idExpediente');
        const tipo = mortgageRequestType.getMortgageTypeText(mortgageRequestConditionsType.get('tipoProducto'));
        const interesVariable = getTinText(conditions, true);
        const taeVariable = (conditions.get('taeProd') * 100).toFixed(2);
        const formatedTae = `${formatAmount(taeVariable)}%`;
        const typeTAE = (tipo === MORTGAGE_TYPE_TEXT.FIJA)
            ? <FormattedText value="mortgageRequestConditions-tae" />
            : <FormattedText value="mortgageRequestConditions-taeVariable" />;
        const amountContent = this.hasMovingCost() ? this.buildAmountWithMovingExpenses() : this.buildAmountWithoutMovingExpenses();

        return (
            <div className="mortgage-request-conditions__table-content-info">
                <ul className="list-unstyled">
                    <li className="mortgage-request-conditions__separator row no-outside-gutter">
                        <div className="mortgage-request-conditions__table-content--item col-xs-6">
                            <FormattedText value="mortgageRequestConditions-titular" />
                        </div>
                        <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                            {titular}
                        </div>
                    </li>

                    <li className="mortgage-request-conditions__separator row no-outside-gutter">
                        <div className="mortgage-request-conditions__table-content--item col-xs-6">
                            <FormattedText value="mortgageRequestConditions-noSolicitud" />
                        </div>
                        <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                            <span>
                                {noSolicitud}
                            </span>
                        </div>
                    </li>
                    {amountContent}
                    <li className="mortgage-request-conditions__separator row no-outside-gutter">
                        <div className="mortgage-request-conditions__table-content--item col-xs-6">
                            <FormattedText value="mortgageRequestConditions-tipo" />
                        </div>
                        <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                            <span>
                                {tipo}
                            </span>
                        </div>
                    </li>

                    <li className="mortgage-request-conditions__separator row no-outside-gutter">
                        <div className="mortgage-request-conditions__table-content--item col-xs-6">
                            <FormattedText value="mortgageRequestConditions-interes" />
                        </div>
                        <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                            <span>
                                {interesVariable}
                            </span>
                        </div>
                    </li>

                    <li className="mortgage-request-conditions__separator row no-outside-gutter">
                        <div className="mortgage-request-conditions__table-content--item col-xs-6">
                            {typeTAE}
                        </div>
                        <div className="mortgage-request-conditions__table-content--amount col-xs-6">
                            <span>
                                {formatedTae}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }

    buildGeneratingBindingOfferWarning() {
        const { mortgageRequestState } = this.props;
        const state = mortgageRequestState.get('estado');
        let content = null;

        if (state === mortgageRequestStates.GENERANDO_OV) {
            content = (
                <div className="row no-outside-gutter mortgage-request-conditions__generating-fein-warning">
                    <OKMessage>
                        <p className="mortgage-request-conditions__generating-fein-description">
                            <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_generatingFeinWarningTextOne" />
                            <OKLink modifier="emphasize" to="/myprofile/mortgage/documentation">
                                <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_generatingFeinWarningTextTwo" />
                            </OKLink>
                        </p>
                    </OKMessage>

                </div>
            )
        }

        return content
    }

    checkFile(docType) {
        const { summaryDocsState } = this.props;
        const fileIdx = summaryDocsState.get('data').findIndex(item =>
            item.get('tipoDocumentoId') === docType &&
            item.get('estado') !== DOCUMENTS_STATUS.NONE &&
            item.get('estado') !== DOCUMENTS_STATUS.PEND_APORTAR &&
            item.get('estado') !== DOCUMENTS_STATUS.EXENTO
        );

        return fileIdx !== -1;
    }

    handleAccountChange(accountId) {
        const { sharedAccountsState, setAccount } = this.props;
        if (!!accountId) {
            const immAccount = sharedAccountsState.getIn(['sharedAccounts', accountId]);
            setAccount(accountId, immAccount.getIn(['balance', 'amount']), immAccount.get('iban'));
        }
    }

    handleFileDownload(evt, documentType) {
        evt.preventDefault();
        this.props.requestDocument({
            documentType
        })
    }

    handlerBindingOfferLinkPDF() {
        const { mortgageRequestState } = this.props;
        const state = mortgageRequestState.get('estado');
        let bindingOfferLinkPDF;
        const downloadBindingOfferText = formatText('mortgageRequestConditions-downloadBindingOfferText');
        const noBindingOfferFound = formatText('mortgageRequestConditions-noBindingOfferFound');

        if (options.indexOf(state) > -1) {
            if (this.state.showBindingOffer) {
                bindingOfferLinkPDF = (
                    <div className="col-xs-4 mortgage-request-conditions__binding-offer-pdf">
                        {this.buildPDFLinks(OV, downloadBindingOfferText, noBindingOfferFound)}
                    </div>
                );
            } else {
                bindingOfferLinkPDF = '';
            }
        }

        return bindingOfferLinkPDF;
    }

    handlerContent() {
        let content = null;
        const { mortgageRequestState, isClientWithoutAccounts } = this.props;
        const state = mortgageRequestState.get('estado');
        const isStateBeforeAprobadoRiesgo = options.indexOf(state) === -1;

        if (isStateBeforeAprobadoRiesgo && !isClientWithoutAccounts) {
            content = (
                <div className="row no-outside-gutter">
                    <div className="mortgage-request-conditions__text">
                        <hr className="mortgage-request-conditions__text-separator" />
                        <strong>
                            <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_noApprovedRisksMessage" />
                        </strong>
                    </div>
                </div>
            );
        }

        return content;
    }

    handlerFiperLinkPDF() {
        const { mortgageRequestState } = this.props;
        const state = mortgageRequestState.get('estado');
        const downloadFiperText = formatText('mortgageRequestConditions-downloadFiperText');
        const noFiperFound = formatText('mortgageRequestConditions-noFiperFound');
        const content = this.buildPDFLinks(FIPER, downloadFiperText, noFiperFound);

        if (options.indexOf(state) > -1 || state === mortgageRequestStates.GENERANDO_OV) {
            return (
                <div className="col-xs-4 mortgage-request-conditions__fliper-pdf-box">
                    {content}
                </div>
            );
        }
    }

    handlerSaveButton(OkButtonProps) {
        const { mortgageRequestState } = this.props;
        const state = mortgageRequestState.get('estado');
        const mortgageRequestStates = require('constants/mortgageRequestStates');

        if (state === mortgageRequestStates.APROBADO_RIESGOS) {
            return (
                <OKButton {...OkButtonProps}>
                    <FormattedText value="mortgageRequestConditions-aceptarCondicionesButton" />
                </OKButton>
            )
        }
    }

    hasMovingCost() {
        const { mortgageRequestConditionsState } = this.props;

        const movingCost = mortgageRequestConditionsState.getIn(['conditions', 'importeFinanciarGastos']);
        return movingCost !== 0;
    }

    shouldDisableSaveButton() {
        const { mortgageRequestConditionsState, mortgageRequestState } = this.props;
        const accountId = mortgageRequestConditionsState.get('accountId');
        const isBindingOffer = mortgageRequestConditionsState.get('isBindingOffer');
        const state = mortgageRequestState.get('estado');
        const fetchingState = mortgageRequestState.get('isFetching');
        const mortgageRequestStates = require('constants/mortgageRequestStates');

        return (
            accountId === null ||
            isBindingOffer ||
            state === mortgageRequestStates.GENERANDO_OV ||
            fetchingState
        )
    }

    buildContentBoxTitle() {
        const { mortgageRequestState, isClientWithoutAccounts } = this.props;
        const state = mortgageRequestState.get('estado');
        let contentBoxTitlekey = 'mortgageRequestConditions-contentBoxTitle';

        if (options.indexOf(state) !== -1 || (isClientWithoutAccounts && state === mortgageRequestStates.APERTURA_CUENTA)) {
            contentBoxTitlekey = 'mortgageRequestConditions-mortgageRequestConditions_approvedRisksTitle';
        }

        return <FormattedText value={contentBoxTitlekey} />;
    }

    getApprovedDocumentsList() {
        const { flagBasedFeatures } = this.props;
        const enabledDocuments = [
            {
                document: FIAE,
                documentFlag: flagBasedFeatures.get('conditions-fiae-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_approvedFiaeDocumentText'
            },
            {
                document: MORTGAGE_WRITING_LETTER,
                documentFlag: flagBasedFeatures.get('conditions-project-contract-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_approvedMortgageWritingLetterDocumentText'
            },
            {
                document: INF_CUOTAS_HIPO,
                documentFlag: flagBasedFeatures.get('conditions-info-mortgages-dues-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_approvedQuotaScenarioDocumentText'
            },
            {
                document: INF_GASTOS_HIPO,
                documentFlag: flagBasedFeatures.get('conditions-info-mortgages-expenses-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_approvedExpensesInfoDocumentText'
            },
            {
                document: ADVERTENCIA_HIPO,
                documentFlag: flagBasedFeatures.get('conditions-advertise-mandatory-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_approvedMandatoryAdviceDocumentText'
            },
            {
                document: INSURANCE_PRE_POLICY,
                documentFlag: flagBasedFeatures.get('conditions-insurances-warranty-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_approvedInsuranceGuaranteeConditionsDocumentText'
            },
            {
                document: NUEVA_LEY_DOC_1,
                documentFlag: flagBasedFeatures.get('conditions-new-law-doc1-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_newMortgageLawDocument1'
            },
            {
                document: NUEVA_LEY_DOC_2,
                documentFlag: flagBasedFeatures.get('conditions-new-law-doc2-enabled'),
                text: 'mortgageRequestConditions-mortgageRequestConditions_newMortgageLawDocument2'
            }
        ];
        return enabledDocuments.map(item => {
            const pdfLink = this.buildPDFLinks(item.document, formatText(item.text));

            if (pdfLink && item.documentFlag) {
                return { name: item.document, value: pdfLink }
            }
        }).filter(element => (element !== undefined));
    }

    buildApprovedLinkDocuments() {
        const { summaryDocsState, mortgageRequestState, flagBasedFeatures } = this.props;
        const state = mortgageRequestState.get('estado');
        const documentationCenter = <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_generatingFeinWarningTextTwo" />;
        let linkPdfFein;

        if (flagBasedFeatures.get('conditions-fein-enabled')) {
            linkPdfFein = this.buildPDFLinks(FEIN, formatText('mortgageRequestConditions-mortgageRequestConditions_approvedFeinDocumentText'));
        }

        const documents = this.getApprovedDocumentsList().map(item => (
            <OKInformativeListItem
                key={item.name}
                className="mortgage-request-conditions__approved-link-documents__others-links-document__link">
                {item.value}
            </OKInformativeListItem>
        ));

        const documentList = (
            <OKInformativeList columns={2}>
                {documents}
            </OKInformativeList>
        );
        let content;
        const hasDocuments = contains(documentsStates, state);

        if (hasDocuments) {
            content = <LoadingSection />;

            if (!summaryDocsState.get('isFetching')) {
                content = (
                    <div className="row no-outside-gutter">
                        <hr className="mortgage-request-conditions__text-separator" />
                        <div className="col-xs-12 mortgage-request-conditions__approved-link-documents">
                            <div className="col-xs-1 mortgage-request-conditions__approved-link-documents__left-column__container">
                                <div className="mortgage-request-conditions__approved-link-documents__left-column__container__icon-container">
                                    <i className="ok-link__icon icon-documento mortgage-request-conditions__approved-link-documents__left-column__container__icon-container__icon" />
                                </div>
                            </div>
                            <div className="col-xs-11 mortgage-request-conditions__approved-link-documents__right-column__container">
                                <div className="mortgage-request-conditions__approved-link-documents__title">
                                    <FormattedText
                                        value="mortgageRequestConditions-mortgageRequestConditions_approvedLinkDocumentsTitle"
                                        className="mortgage-request-conditions__approved-link-documents__title__value"
                                    />
                                    <br />
                                    <FormattedText
                                        value="mortgageRequestConditions-mortgageRequestConditions_approvedLinkDocumentsTitleInfo"
                                        className="mortgage-request-conditions__approved-link-documents__title__info"
                                    />
                                </div>

                                <div className="mortgage-request-conditions__approved-link-documents__fein-link-document">
                                    {linkPdfFein}
                                </div>

                                <div className="mortgage-request-conditions__approved-link-documents__others-links-document">

                                    <div className="mortgage-request-conditions__approved-link-documents__others-links-document__info">
                                        <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_approvedLinkDocumentsListTitle" />
                                    </div>
                                    {documentList}
                                </div>
                                <br />
                                <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_approvedLinkDocumentsFooterInfo" />
                                <OKLink
                                    modifier="emphasize"
                                    to="/myprofile/mortgage/documentation"
                                >
                                    {documentationCenter}
                                </OKLink>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return content;
    }

    handleAddMovingExpenses() {
        this.props.history.push('/myprofile/mortgage/moving-expenses');
    }

    handleRejectMovingExpenses() {
        this.props.acceptMovingFee(0, this.props.history);
    }

    buildAddMovingExpensesOption() {
        const { mortgageRequestState, mortgageRequestConditionsState } = this.props;
        const state = mortgageRequestState.get('estado');
        const maxFinanceExpensesValue = mortgageRequestConditionsState.getIn(['conditions', 'maximoImporteFinanciarGastos']);
        const formattedMaxFinanceExpenses = MortgageRequestCurrencyHelp({ currency: maxFinanceExpensesValue, withDecimals: false });
        let content = null;

        if (!this.hasMovingCost() && maxFinanceExpensesValue > 0 && state === mortgageRequestStates.OFRECER_FINANCIACION_GASTOS) {
            content = (
                <div className="mortgage-request-conditions__add-moving-expenses">
                    <FormattedText
                        value="mortgageRequestConditions-mortgageRequestConditions_addMovingExpensesTitle"
                        className="mortgage-request-conditions__add-moving-expenses-title"
                        injectedStrings={[formattedMaxFinanceExpenses]}
                    />
                    <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_addMovingExpensesParagraph" />
                    <div className="mortgage-request-conditions__add-moving-expenses-buttons">
                        <OKButton
                            modifier="secondary"
                            onClick={this.handleAddMovingExpenses}
                        >
                            <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_addMovingExpensesAcceptButtonLabel" />
                        </OKButton>
                        <div className="mortgage-request-conditions__add-moving-expenses-buttons--right">
                            <OKButton
                                modifier="ghost"
                                onClick={this.handleRejectMovingExpenses}
                            >
                                <FormattedText value="mortgageRequestConditions-mortgageRequestConditions_addMovingExpensesRejectButtonLabel" />
                            </OKButton>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }

    render() {
        const {
            mortgageRequestConditionsState,
            mortgageRequestConditionsType
        } = this.props;
        const loadingConditions = mortgageRequestConditionsState.get('isFetching');
        const loadingType = mortgageRequestConditionsType.get('isFetching');
        const variableType =  mortgageRequestConditionsType.get('tipoProducto');
        const mortgageConditionsProductType = mortgageRequestType.getMortgageTypeText(mortgageRequestConditionsType.get('tipoProducto'));
        const isBindingOffer = mortgageRequestConditionsState.get('isBindingOffer');

        const mortgageOpen = formatText('mortgageRequestConditions-mortgageOpen', [mortgageConditionsProductType]);
        const loadingConditionsClassname = classnames({ hidden: !loadingConditions });
        const conditionsClassname = classnames('row', { hidden: loadingConditions });
        const loadingInfoPanel = classnames({ hidden: !loadingType });
        const infoPanelClassname = classnames({ hidden: loadingType });

        const OkButtonProps = {
            onClick: this.aceptedBindingOffer,
            disabled: this.shouldDisableSaveButton(),
            loading: isBindingOffer
        };
        const saveButton = this.handlerSaveButton(OkButtonProps);
        const monthlyQuota = formatText('mortgageRequestConditions-mortgageRequestConditions_monthlyFee');

        const infoProps = {
            title: mortgageOpen,
            amount: mortgagesContionsMonthlyFeeSubtitleText(mortgageRequestConditionsState.get('conditions'), false),
            message: monthlyQuota
        };

        const generatingBindingOfferWarning = this.buildGeneratingBindingOfferWarning();
        const buildAccountSelect = this.buildAccountSelect();
        const buildhandlerContent = this.handlerContent();
        const contentBoxTitle = this.buildContentBoxTitle();
        const buildApprovedLinkDocuments = this.buildApprovedLinkDocuments();
        const addMovingExpenses = this.buildAddMovingExpensesOption();
        const contentBoxSubtitle = formatText('mortgageRequestConditions-contentBoxSubtitle');

        return (
            <div className="mortgage-request-conditions">
                <ContentBox>
                    <div className="mortgage-request-conditions__content">
                        <div className="mortgage-request-conditions__title">
                            <OKBoxTitle value={contentBoxTitle} children={contentBoxSubtitle} />
                        </div>
                        <div className="mortgage-request-conditions row no-outside-gutter">
                            <div className={loadingConditionsClassname}>
                                <LoadingSection />
                            </div>
                            <div className={conditionsClassname}>
                                <div className="col-xs-8">
                                    {this.buildTable()}
                                </div>
                                <div className="col-xs-4">
                                    <div className={loadingInfoPanel}>
                                        <LoadingSection />
                                    </div>
                                    <div className={infoPanelClassname}>
                                        <MortgageRequestInfo {...infoProps} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {addMovingExpenses}
                        {buildhandlerContent}
                        {generatingBindingOfferWarning}
                        {buildAccountSelect}
                        {buildApprovedLinkDocuments}
                        <div className="mortgage-request-conditions__content-action-divider">
                            <div className="mortgage-request-conditions__content-action-divider__buttons clearfix">
                                <OKLink modifier="inherit-styles" to="/myprofile/mortgage/panel">
                                    <FormattedText value="mortgageRequestCommons-returnText" />
                                </OKLink>
                                <div className="pull-right">
                                    {saveButton}
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentBox>
                <p className="mortgage-request-conditions__footer">
                {variableType !== MORTGAGE_TYPE.FIJO && formatText('mortgageRequestMortgageEdit-mortgageModifyLegalText')}
                </p>
            </div>
        );
    }
}

MortgageRequestConditions.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    mortgageRequestConditionsState: PropTypes.object,
    mortgageRequestConditionsType: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    immAccounts: PropTypes.object.isRequired,
    sharedAccountsState: PropTypes.object,
    summaryDocsState: PropTypes.object,
    requestConditions: PropTypes.func,
    resetBlockedAccounts: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    requestAcceptOffer: PropTypes.func.isRequired,
    mortgageRequestIsBindingOfferReset: PropTypes.func,
    requestSharedAccounts: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
    requestDocument: PropTypes.func,
    isClientWithoutAccounts: PropTypes.bool,
    flagBasedFeatures: PropTypes.object,
    acceptMovingFee: PropTypes.func,
};

module.exports.constructor = MortgageRequestConditions;
module.exports.MortgageRequestConditions = connect(
    state => ({
        mortgageRequestConditionsState: state.mortgageRequestConditions,
        mortgageRequestConditionsType: state.mortgageRequestConditionsType,
        mortgageRequestState: state.mortgageRequestState,
        immAccounts: state.accounts,
        sharedAccountsState: state.sharedAccounts,
        summaryDocsState: state.mortgageRequestSummaryDocumentation,
        flagBasedFeatures: state.flagBasedFeatures
    }),
    {
        acceptMovingFee: mortgateRequestMovingExpensesAction.acceptMovingFee,
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        mortgageRequestIsBindingOfferReset: mortgageRequestConditionsActions.isBindingOfferReset,
        requestAcceptOffer: mortgageRequestConditionsActions.aceptBindingOffer,
        requestConditions: mortgageRequestConditionsActions.requestConditions,
        requestDocument: documentActions.getDocument,
        requestSharedAccounts: sharedAccounts.requestSharedAccounts,
        requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        setAccount: mortgageRequestConditionsActions.setAccount,
    }
)(withRouter(MortgageRequestConditions));
